<template>
  <div id="speed-wrap123" ref="car" style="transform: scale(0.8)">
    <div id="car-bg" :class="{ blind: $store.state.isdark }"></div>
    <div id="speed"></div>
    <div id="licheng">
      <Col span="16">
        <p>
          <span
            >{{
              (data[curentPoint].mileage - data[0].mileage).toFixed(2)
            }}/km</span
          >
          累计{{ data[curentPoint].mileage }} / km
        </p>
        <p>{{ utils.time(data[curentPoint].gpsTime) }}</p>
      </Col>
    </div>
  </div>
</template>
<script>
import echarts from "echarts";
var pageSize = 1;
export default {
  props: ["curentPoint"],
  data() {
    return {
      isPlay: true,
      data: [{ mileage: 100, time: 100, address: 123, speed: 20 }],
    };
  },
  methods: {
    speed(id, value) {
      this.chart = echarts.init(document.getElementById(id), "light");
      this.option = {
        backgroundColor: "",
        tooltip: {
          formatter: "{a} <br/>{c} {b}",
        },
        toolbox: {
          show: true,
          feature: {
            mark: { show: true },
            restore: { show: true },
            saveAsImage: { show: true },
          },
        },
        series: [
          {
            name: "速度",
            type: "gauge",
            min: 0,
            max: 180, //最大值
            startAngle: 180,
            endAngle: 0,
            splitNumber: 6,
            center: ["50%", "92%"], // 默认全局居中
            radius: "140%",
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: [
                  [0.09, "lime"],
                  [0.82, "#1e90ff"],
                  [1, "#ff4500"],
                ],
                width: 3,
                shadowColor: "#fff", //默认透明
                shadowBlur: 10,
              },
            },
            axisLabel: {
              // 坐标轴小标记
              fontWeight: "bolder",
              color: "#fff",
              shadowColor: "#fff", //默认透明
              shadowBlur: 10,
            },
            axisTick: {
              // 坐标轴小标记
              length: 15, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: "auto",
                shadowColor: "#fff", //默认透明
                shadowBlur: 10,
              },
            },
            splitLine: {
              // 分隔线
              length: 25, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                width: 2,
                color: "#fff",
                shadowColor: "#fff", //默认透明
                shadowBlur: 10,
              },
            },
            pointer: {
              // 分隔线
              shadowColor: "#fff", //默认透明
              shadowBlur: 5,
            },
            title: {
              offsetCenter: [0, "-20"], // 单位L的位置
              textStyle: {
                // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                fontWeight: "",
                fontStyle: "italic",
                color: "#fff",
                shadowColor: "#fff", //默认透明
                shadowBlur: 10,
                fontSize: "12",
              },
            },
            detail: {
              //数字修改
              borderColor: "#fff",
              shadowColor: "#fff", //默认透明
              shadowBlur: 5,
              width: 80,
              height: 30,
              offsetCenter: [0, "-40"], // 数字位置
              textStyle: {
                // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                fontWeight: "",
                color: "#fff",
                fontSize: "30",
              },
            },

            data: [{ value: 50, name: "km/h" }],
          },
          {
            name: "油表",
            type: "gauge",
            center: ["84%", "70%"], // 调整仪表位置
            radius: "85%",
            min: 0,
            max: 120, //最大值
            startAngle: 145, //开始旋转点
            endAngle: -30, //结束旋转点
            splitNumber: 6,
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: [
                  [0.2, "lime"],
                  [0.8, "#1e90ff"],
                  [1, "#ff4500"],
                ],
                width: 2,
                shadowColor: "#fff", //默认透明
                shadowBlur: 10,
              },
            },
            axisTick: {
              // 坐标轴小标记
              length: 12, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: "auto",
                shadowColor: "#fff", //默认透明
                shadowBlur: 10,
              },
            },
            axisLabel: {
              fontWeight: "",
              color: "#fff",
              shadowColor: "#fff", //默认透明
              shadowBlur: 10,
              formatter: function (v) {
                switch (v + "") {
                  case "0":
                    return "E";
                  case "1":
                    return "Gas";
                  case "2":
                    return "F";
                }
              },
            },
            splitLine: {
              // 分隔线
              length: 20, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                width: 3,
                color: "#fff",
                shadowColor: "#fff", //默认透明
                shadowBlur: 10,
              },
            },
            pointer: {
              width: 4,
              shadowColor: "#fff", //默认透明
              shadowBlur: 5,
            },
            title: {
              offsetCenter: [0, "-40%"], // 单位L的位置
              textStyle: {
                // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                fontWeight: "bolder",
                fontStyle: "italic",
                color: "#fff",
                shadowColor: "#fff", //默认透明
                shadowBlur: 10,
              },
            },
            detail: {
              //数字修改
              borderColor: "#fff",
              shadowColor: "#fff", //默认透明
              shadowBlur: 5,
              width: 80,
              height: 30,
              offsetCenter: [0, "30%"], // 数字位置
              textStyle: {
                // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                fontWeight: "",
                color: "#fff",
                fontSize: "18",
              },
            },
            data: [{ value: 12.6, name: "L" }],
          },
        ],
      };
      var that = this;
      /* setInterval(function() {
       option.series[0].data[0].value = (Math.random() * 100).toFixed(2) - 0;
        option.series[1].data[0].value = (Math.random() * 7).toFixed(2) - 0;
        option.series[2].data[0].value = (Math.random() * 2).toFixed(2) - 0;
        option.series[3].data[0].value = (Math.random() * 2).toFixed(2) - 0;
        myChart.setOption(option);
      }, 2000);*/
      this.chart.setOption(this.option);
    },
    setWidth(t) {
      this.data = t;
      var w = document.body.clientWidth - 50;
      var nw = 1920;
      pageSize = w / nw;
      //pageSize = 0.5
      this.$refs.car.style.transform = "scale(" + pageSize + ")";
      this.speed("speed");
    },
  },
  mounted() {
    //this.speed("speed");
    //window.addEventListener("resize", this.adaptation);
    //this.adaptation();
  },
  watch: {
    curentPoint(v) {
      console.log(v);
      this.option.series[0].data[0].value = this.data[v].speed;
      this.option.series[1].data[0].value = this.data[v].oil;
      /* this.option.series[1].data[0].value = (
        30 -
        (this.data[v].mileage - this.data[0].mileage) * 0.3
      ).toFixed(2); */
      this.chart.setOption(this.option);
    },
  },
};
</script>
<style lang="">
#speed-wrap123 {
  width: 1920px;
  height: 210px;
  position: relative;
  display: flex;
  transform-origin: left bottom;
  position: absolute;
  bottom: 0;
  left: 0;
}
#car-bg {
  width: 1920px;
  height: 530px;
  background: url(../../assets/driver.png);
  position: relative;
  display: flex;
  transform-origin: left bottom;
  position: absolute;
  bottom: 0;
  left: 0;
  /* 元素遮罩层不遮挡下方元素的代码 */
  -webkit-pointer-events: none;
  -moz-pointer-events: none;
  -ms-pointer-events: none;
  -o-pointer-events: none;
  pointer-events: none;
}
.blind {
  -webkit-filter: brightness(1.7);
  filter: brightness(1.7);
}
#speed {
  width: 600px;
  height: 200px;
  bottom: 0;
  margin-top: 0px;
  margin-left: 240px;
}
#licheng {
  color: #dcefff;
  margin-top: 80px;
  margin-left: 300px;
  width: 400px;
}

#licheng p {
  margin-bottom: 10px;
  line-height: 1;
  font-weight: lighter;
  color: #fff;
  line-height: 1.5;
  font-size: 14px;
}
#licheng p span {
  font-size: 30px;
  margin-right: 10px;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/locusPeson/driverModal.vue